import React from "react";
import { useTranslation } from "react-i18next";

export default function AppealExpiryAlertBody() {
    const { t } = useTranslation();
    return (
        <React.Fragment>
            <span>{t('Appeal.Common.dispute-line-two')}</span>
        </React.Fragment>
    )
}